import { AnyPrivileges } from '../../shared/privilege-guard';
import { AuthGuard } from './../../shared/auth-guard';
import { AdminComponent } from './admin.component';
import { CustomersComponent } from './customers/customers.component';
import { ResearchPortalAccessDeniedComponent } from './research-portal-access-denied/research-portal-access-denied.component';
import { ResearchPortalStatsComponent } from './research-portal-stats/research-portal-stats.component';
// import { AdminRoleGuard, CustomerRoleGuard, PortalRoleGuard } from './../../shared/role-guard';

export const adminRoutes = [
  {
    path: '',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'admin/customers',
        canActivate: [AnyPrivileges],
        data: { privileges: ['ADMIN_OPTIONS', 'REVIEW_PRODUCT_SIGNUP', 'LIST_CUSTOMER'] },
        component: CustomersComponent,
        animation: { value: 'customers' },
      },

      {
        path: 'admin/research-portal-access-denied',
        component: ResearchPortalAccessDeniedComponent,
        animation: { value: 'customers' },
      },

      {
        path: 'admin/research-portal-stats',
        canActivate: [AnyPrivileges],
        data: { privileges: ['ADMIN_OPTIONS', 'REVIEW_PRODUCT_SIGNUP'] },
        component: ResearchPortalStatsComponent,
        animation: { value: 'customers' },
      },
    ],
  },
];
